export default __webpack_public_path__ + "static/media/1000_4 1.ffb33bba.svg";